<template>
  <div class="cityList">
    <div v-if="show == 0">
      <van-nav-bar
        title="您在哪下车"
        left-text="城市中文名"
        right-text="取消"
        @click-right="onClickRight"
      />
      <van-cell>
        <!-- 使用 title 插槽来自定义标题 -->
        <template slot="title">
          <span class="custom-title">当前城市定位:</span>
          <span class="poscity">{{ posCity }}</span>
        </template>
      </van-cell>
      <van-index-bar :index-list="indexList">
        <div v-for="(value, index) in cityList" :key="index">
          <van-index-anchor :index="value.name" />
          <van-cell
            v-for="(item, index) in value.cities"
            :title="item.name"
            :key="index"
          />
        </div>
      </van-index-bar>
    </div>
    <div v-else>
      <van-nav-bar
        left-text="城市中文名"
        right-text="取消"
        @click-right="onClickRight"
      />

      <div class="mot"></div>
      <div v-for="(c, i) in cityl" :key="i" class="list" @click="cellClick(c)">
        {{ c.cityName }}
      </div>
    </div>
  </div>
</template>

<script>
import cityList from "@/utlis/cityList.js";
import { IndexBar, IndexAnchor, Cell, NavBar } from "vant";

export default {
  name: "city",
  data() {
    return {
      cityList,
      posCity: "北京市",
      indexList: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "J",
        "K",
        "L",
        "M",
        "N",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "W",
        "X",
        "Y",
        "Z",
      ],
      show: 0,
      cityl: [],
      dq: "",
      id: "",
      num: null,
    };
  },
  components: {
    "van-nav-bar": NavBar,
    "van-index-bar": IndexBar,
    "van-index-anchor": IndexAnchor,
    "van-cell": Cell,
  },
  methods: {
    onClickRight() {
      this.$router.back();
    },
    cellClick(c) {
      console.log(c);

      if (this.num == "2") {
        this.$router.replace({
          path: `homeManager?cityCode=${c.cityCode}&cityName=${c.cityName}&num=${this.num}`,
        });
      }
    },
  },

  mounted() {
    console.log("====================================");
    console.log(this.$route);
    console.log("====================================");
    this.num = "0";
    if (this.$route.query.num == "2") {
      this.num = this.$route.query.num;
    }

    if (this.$route.path == "/city") {
      this.dq = this.$route.query.name;
      this.show = "/city";
      // 车队长管理城市
      this.$axios({
        url: `/vedm/captainApp/captainCityList/${localStorage.getItem(
          "accountUid"
        )}`,
        method: "get",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.data.code == 0) {
            console.log(res.data.data);
            res.data.data.unshift({
              cityName:'全部',
              cityCode:''

            })
            this.cityl = res.data.data;


            //  this.cityList=res.data.data
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      this.show = 0;
    }
  },
};
</script>

<style scoped lang="less">
.list {
  width: 375px;
  height: 44px;
  background: #ffffff;
  padding: 0 0 0 15px;
  color: black;
  font-size: 12px;
  display: flex;
  align-items: center;
  caret-color: rgba(0, 0, 0, 0);
}
.mot {
  width: 100%;
  height: 10px;
  background: #f7f7f7;
  caret-color: rgba(0, 0, 0, 0);
}
.cityList {
  width: 100%;
  background-color: rgba(240, 240, 240, 1);
  .van-nav-bar__text {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(98, 104, 112, 1);
  }
  .van-cell {
    .custom-title {
      display: inline-block;
      margin-right: 8px;
    }
    .poscity,
    .custom-title {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 37, 41, 1);
    }
  }
}
</style>
